module.exports = __webpack_public_path__ + "static/media/logo.fa49e8b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Landing/img/logo.svg
// module id = 1379
// module chunks = 0